import styled, { keyframes, css } from 'styled-components';
import { fadeIn } from '../base/keyframes/fades';
import { zIndex } from '../global/globals';
import { clearButtonStyles } from '../base';
import media from '../base/media';

const modalOpen = keyframes`
	0% { opacity: 0; transform: scale3d(1.1, 1.1, 1); }
	100% { opacity: 1; transform: scale3d(1, 1, 1); }
`;

export const Overlay = styled.div`
	position: absolute;
	top: 0; left: 0;
	right: 0; bottom: 0;
	z-index: 1;
	background: rgba(255, 255, 255, 0.8);
	animation: ${fadeIn} 100ms;
	backface-visibility: hidden;
`;

export const Content = styled.div`
	max-height: 90vh;
	max-width: 100%;
	position: relative;
	z-index: 2;
	opacity: 0;
	animation: ${modalOpen} 300ms ease forwards;
`;

export const Wrapper = styled.div`
	position: fixed;
	display: flex;
	justify-content: center;
	top: 0; left: 0;
	right: 0; bottom: 0;
	align-items: center;
	z-index: ${zIndex.modals};
	transition: opacity 250ms ease;

	${({ closing }) => closing && css`
		opacity: 0;
		pointer-events: none;
	`}
`;

export const CloseButton = styled.button`
	${clearButtonStyles};
	display: flex;
	justify-content: center;
	align-items: center;
	position: absolute;
	top: -3rem;
	right: 0;
	padding: 0.5rem;
	background-color: #fff;
	border: 1px solid ${({ theme }) => theme.colors.borderColor};
	border-radius: 100%;
	transition: background-color 150ms ease;
	cursor: pointer;

	&:hover {
		background-color: ${({ theme }) => theme.colors.grayLighter2};
	}

	${media.tablet`
		top: -1.5rem;
		right: -1.2rem;
	`}
`;
